import { ErrorHandler } from '@angular/core';

export class SkitbsErrorHandler implements ErrorHandler {

	handleError(error) {
		console.error("[SkitbsErrorHandler]", error);
	}
}